import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ActivationEnd, NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { RatingComponent } from '../rating/rating.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { filter } from 'rxjs/operators';
import { HttpClientModule } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { HighlightPipe } from '../../../Pipes/highlight.pipe';
import { SearchService } from '../../../Services/api';
import { HttpService } from '../../../Services/http';

@Component({
  selector: 'app-search-result',
  imports: [CommonModule, HeaderComponent, FooterComponent, RatingComponent, MatIconModule, MatCheckboxModule, FormsModule, MatPaginatorModule, MatButtonModule, HttpClientModule, RouterModule, HighlightPipe],
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.scss'
})
export class SearchResultComponent {
  allLabels: any = []
  allContent: any = []
  filteredLabels: any = []
  labels: any[] = []
  filteredContent: any = []
  isSmallScreen!: Boolean
  searchParam: any
  count: number = 0;
  taxTypes: any[] = [];
  categories: any[] = [];
  paginatedItems: any[] = [];
  showFilters: boolean = true;
  showFilterIcon: boolean = false;
  showApply: boolean = false;
  browserRefresh = false;
  subscription: Subscription;

  /**
   * The constructor function initializes variables and subscribes to changes in the search service
   * state to update the component's data accordingly.
   * @param {Router} router - The `router` parameter is an instance of the Angular Router service,
   * which provides navigation and URL manipulation capabilities for your Angular application. It
   * allows you to navigate between different components and routes within your application.
   * @param {SearchService} searchService - The `searchService` parameter is an instance of the
   * `SearchService` class, which is used to manage search functionality in the application. It
   * provides methods and observables for searching and filtering data based on user input. In the
   * constructor code snippet you provided, the `searchService.state$` observable
   * @param {HttpClient} http - The `http` parameter in the constructor is an instance of the
   * `HttpClient` class provided by Angular's `@angular/common/http` module. This service allows you to
   * make HTTP requests to a server to fetch or send data. It is commonly used for interacting with
   * APIs to retrieve or send data in
   */
  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object, private searchService: SearchService, private httpService: HttpService) {

    this.searchService.state$.subscribe((state: any) => {
      console.log("search term", state);
      this.searchParam = state.searchTerm;
      this.allLabels = state.labelList;
      this.allContent = state.contentList;

      if (this.searchParam && this.allLabels && this.allLabels && typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('searchVal', this.searchParam)
        localStorage.setItem('allSearchedLabels', JSON.stringify(this.allLabels))
        localStorage.setItem('allSearchedContent', JSON.stringify(this.allContent))
      }

      this.filteredLabels = this.allLabels
      this.filteredContent = this.allContent
      this.count = this.filteredLabels?.length + this.filteredContent?.length
      // this.taxTypes = data.taxType
      // this.categories = data.categories

      console.log("all labels", this.allLabels);
      console.log("allContent", this.allContent);

      this.ngOnInit();
    })

    this.subscription = router.events.subscribe(async (event) => {
      console.log("browser event", event);
      console.log("browser status", router.navigated);
      if (event instanceof ActivationEnd) {
        this.browserRefresh = !router.navigated;
        console.log("browser refresh", this.browserRefresh);
        if (this.browserRefresh && typeof window !== 'undefined' && window.localStorage) {
          this.reloadedPage()
        }
      }
    });

  }

  /**
   * The `ngOnInit` function initializes component properties based on window size, subscribes to
   * router events to fetch data for search page, and updates paginated items and labels.
   */
  ngOnInit() {

    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
    if (typeof window !== 'undefined' && window.innerWidth < 1000) {
      this.showFilters = false;
      this.showFilterIcon = true;
    }

    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: any) => {
    //     if (event.url === '/search') {
    //       this.http.get('../../../../assets/JSONData/searchTC.json').subscribe((data: any) => {
    //         this.taxTypes = data.taxType
    //         this.categories = data.categories
    //       });

    //     }
    //   });

    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          if (event.url === '/search') {
            this.httpService.getJsonData('JSONData/searchTC.json', '').then(result => {
              if (result?.status === 200) {
                const data = result.response;
                this.taxTypes = data.taxType || [];
                this.categories = data.categories || [];
              } else {
                this.taxTypes = [];
                this.categories = [];
              }
            }).catch(err => {
              console.error('Failed to load searchTC JSON', err);
              this.taxTypes = [];
              this.categories = [];
            });
          }
        });
    }

    this.updatePaginatedItems(0, 5);
    this.updatePaginatedLabels(0, 6);
  }


  /* The `@HostListener('window:resize', [''])` decorator in the `onResize` method is used in
  Angular to listen for the `resize` event on the window object. */
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (typeof window !== 'undefined' && event.target.innerWidth < 1000) {
      this.showFilters = false;
      this.showFilterIcon = true;
    }
  }


  /**
   * The onPageChange function updates paginated items based on the page index and page size provided
   * in the event.
   * @param {PageEvent} event - The `event` parameter in the `onPageChange` function is of type
   * `PageEvent`. It contains information about the page change event, such as the `pageIndex` (index
   * of the new page) and `pageSize` (number of items per page).
   */
  onPageChange(event: PageEvent) {
    const startIndex = event.pageIndex * event.pageSize;
    this.updatePaginatedItems(startIndex, event.pageSize);
  }

  /**
   * The function `onLabelChange` updates paginated labels based on the page index and page size
   * provided in the `PageEvent`.
   * @param {PageEvent} event - The `event` parameter in the `onLabelChange` function is of type
   * `PageEvent`. It contains information about the page index and page size that triggered the event.
   */
  onLabelChange(event: PageEvent) {
    const startIndex = event.pageIndex * event.pageSize;
    this.updatePaginatedLabels(startIndex, event.pageSize);
  }


  updatePaginatedItems(startIndex: number, pageSize: number) {
    this.paginatedItems = this.filteredContent?.slice(startIndex, startIndex + pageSize);
  }

  updatePaginatedLabels(startIndex: number, pageSize: number) {
    this.labels = this.filteredLabels?.slice(startIndex, startIndex + pageSize);
  }

  routeToPage(route: string) {
    this.router.navigate([`${route}`])
  }

  openFilter() {
    this.showFilters = true;
  }

  closeFilter() {
    this.showFilters = false;
  }

  enableApply() {
    this.showApply = [...this.taxTypes, ...this.categories].some(item => item.selected);

    if (!this.showApply) {
      this.filteredLabels = this.allLabels
      this.filteredContent = this.allContent
      this.count = this.filteredLabels?.length + this.filteredContent?.length
      this.updatePaginatedItems(0, 5);
      this.updatePaginatedLabels(0, 6);
    }
  }

  async filterIt() {
    let filteredData = await this.applyFilters()
    this.filteredLabels = filteredData.headings
    this.filteredContent = filteredData.data

    console.log("filteredLabels", filteredData)
    this.updatePaginatedItems(0, 5);
    this.updatePaginatedLabels(0, 6);
    this.count = this.filteredLabels?.length + this.filteredContent?.length
  }

  async applyFilters(): Promise<{ data: any[]; headings: any[] }> {
    const selectedTaxTypes = new Set(
      this.taxTypes.filter(t => t.selected).map(t => t.value.toLowerCase())
    );
    const selectedCategories = new Set(
      this.categories.filter(c => c.selected).map(c => c.name.toLowerCase())
    );

    const filteredData = this.allContent.filter((item: any) =>
      selectedTaxTypes.has(item.tax_type?.toLowerCase()) ||
      selectedCategories.has(item.section?.toLowerCase()) ||
      selectedCategories.has(item.tab?.toLowerCase())
    );

    const filteredHeadings = this.allLabels.filter((label: any) =>
      selectedTaxTypes.has(label.tax_type?.toLowerCase()) ||
      selectedCategories.has(label.label?.toLowerCase())
    );

    return { data: filteredData, headings: filteredHeadings };
  }

  async reloadedPage() {
    console.log("page reloaded");
    this.searchParam = localStorage.getItem('searchVal')
    this.allLabels = JSON.parse(localStorage.getItem('allSearchedLabels')!)
    this.allContent = JSON.parse(localStorage.getItem('allSearchedContent')!)

    console.log("searchVal on reload", this.searchParam);
    console.log("all labels on reload", this.allLabels);
    console.log("all content on reload", this.allContent);

    this.filteredLabels = this.allLabels
    this.filteredContent = this.allContent
    this.count = this.filteredLabels?.length + this.filteredContent?.length
    // this.taxTypes = data.taxType
    // this.categories = data.categories


    this.ngOnInit()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
